import { InitUpdateTrip, OrderSummary } from '@/features/reservation/ui'
import { TripDetailsModel } from '@/features/trips/types/models/trip-details.model'
import { getTranslations } from 'next-intl/server'

type Props = {
  trip: TripDetailsModel
  children: React.ReactNode
}

export const UpdateTripLayout: React.FC<Props> = async ({ trip, children }) => {
  const t = await getTranslations()

  return (
    <>
      <h1 className='my-8 text-2xl font-medium'>
        {t('actions.updateTrip')} #{trip.id}
      </h1>

      <div className='relative flex flex-col-reverse gap-6 md:grid md:grid-cols-12 md:gap-x-8'>
        <section
          aria-labelledby='trip-details-heading'
          className='border-grey-5 col-span-8 flex flex-col gap-6 rounded border p-4'
        >
          {children}
        </section>

        <aside
          aria-labelledby='order-summary-heading'
          className='relative top-16 left-0 col-span-4 mb-10 self-start md:sticky md:mb-0'
        >
          <OrderSummary />
        </aside>
      </div>

      <InitUpdateTrip trip={trip} />
    </>
  )
}
